import React, { useState, useEffect } from 'react';
import { Row, Col, Button, Progress } from 'antd';
import Couples from '../../base/Couples';
import Result from '../../base/result';
import { generateRandomNumberSeries } from '../../../utils';
import './index.less';
import { t } from '../../../languages';
// import ExerciseBlocker from '../../Utils/ExerciseBlocker';
import moment from 'moment';
import { generateMemoSeries, getRandomMessage2 } from '../utils';
import BackMusic from '../../base/BackMusic';

const MemoSet = (props) => {
    const [state, setState] = useState({
        eid: 0,
        series: [],
        current: 0,
        results: [],
        times: [],
        message: null,
        message2: null,
        showresults: false,
        timeout: false,
        level: null,
    });
    const [initMoment, setInitMoment] = useState(0);

    useEffect(() => {
        setInitMoment(moment());
        handleRepeat();
    }, []);

    const handleRate = (timereq) => {
        const { results, times } = state;
        const current_time = timereq;
        const current_result = 1;

        const message = `${t(props.lang, 'bravosur')}`;
        const message2 = current_result ? t(props.lang, getRandomMessage2('great')) : t(props.lang, getRandomMessage2('nodiscorage'));

        setState((prevState) => ({
            ...prevState,
            results: [...results, current_result],
            times: [...times, current_time],
            message,
            message2,
        }));
    };

    const handleNext = () => {
        const { current, series } = state;

        if (current < series.length - 1) {
            const new_current = current + 1;
            const level = series[new_current];

            setState((prevState) => ({
                ...prevState,
                current: new_current,
                message: null,
                message2: null,
                ready: false,
                timeout: false,
                level,
                showresults: false
            }));

            /* setTimeout(() => {
                setState((prevState) => ({ ...prevState, timeout: true }));
            }, level.time * 1000); */
        } else {
            const { params, uid, eid, saveResult } = props;
            const num = params.num;
            const hits = state.results.reduce((acc, aR) => acc + aR, 0);
            const errors = num - hits;
            const passed = errors > params.errors ? 0 : 1;
            const coins = params.coins;
            const elapsedTime = moment().diff(initMoment, 'seconds');

            const totalTime = state.times.reduce((acc, aT) => acc + aT, 0);

            saveResult(
                uid,
                `${uid}-${eid}`,
                { id: 'MS', uid, eid, p: passed, h: hits, e: errors, c: passed ? coins : 0, time: totalTime, r: state.results, s: series, et: elapsedTime },
                state.times
            );

            setState((prevState) => ({
                ...prevState,
                showresults: true,
            }));
        }
    };

    const handleRepeat = () => {
        const params = props.params;

        const series = generateMemoSeries(params);

        const level = series[0];

        setState({
            series,
            current: 0,
            results: [],
            times: [],
            message: null,
            message2: null,
            showresults: false,
            ready: false,
            timeout: false,
            level,
        });

        /* setTimeout(() => {
            setState((prevState) => ({ ...prevState, timeout: true }));
        }, level.time * 1000); */
    };

    const handleComplete = (timereq) => {
        // console.log('MemoSet handleComplete:', timereq);
        handleRate(timereq);
        /* For competitions */
        const sendResultsOnComplete = props.params.sendResultsOnComplete || false;
        if (sendResultsOnComplete) {
            const { uid, eid, saveResult } = props;
            saveResult(uid, `${uid}-${eid}`, { id: 'MS', uid, eid, p: 1 }, timereq);
        }
    };

    const {
        current,
        series,
        results,
        message,
        message2,
        showresults,
        timeout,
        level,
    } = state;

    const rate = results[current];
    const messagestyle = message ? (!rate ? ' error' : ' valid') : '';
    const percent = Math.round((current / series.length) * 100);
    const is_test = props.params.is_test ? props.params.is_test : false;

    /* For competitions */
    const showSolution = props.params.showSolution || false;
    const hideNextButton = props.params.hideNextButton || false;

    if (!showresults) {
        if (!level) return null;

        return (
            <Row className="exercise">
                <BackMusic source={'random'} />

                {!is_test && (
                    <Col span={21} className="progress-bar">
                        <Progress percent={percent} showInfo={false} />
                    </Col>
                )}

                {!message && (
                    <Col span={24} className="exercise-body memo-body">
                        <section className="memoset">
                            <article className="couples">
                                {!message && (
                                    <Couples
                                        key={current}
                                        showBack={!showSolution}
                                        type={'abacus'}
                                        items={level.length}
                                        beads={1}
                                        series={level}
                                        onComplete={handleComplete}
                                    />
                                )}
                            </article>
                        </section>
                    </Col>
                )}

                {message && !hideNextButton && (
                    <Col span={24}>
                        <Row className={`botones memoset${messagestyle}`}>
                            <Col span={24} className="message">
                                {message}
                            </Col>
                            {message2 && (
                                <Col span={24} className="message">
                                    {message2}
                                </Col>
                            )}
                            {message && (
                                <Col span={24}>
                                    <Button
                                        key="submit"
                                        type="primary"
                                        onClick={handleNext}
                                        style={{ width: '90%' }}
                                    >
                                        {t(props.lang, 'next')}
                                    </Button>
                                </Col>
                            )}
                        </Row>
                    </Col>
                )}
            </Row>
        );
    } else {
        const params = { ...props.params, num: series.length, show_time: true };

        return (
            <Result
                params={params}
                results={results}
                handleRepeat={handleRepeat}
                handleCancel={props.handleCancel}
                lang={props.lang}
            />
        );
    }
};

export default MemoSet;